import { initializeConnector } from "@web3-react/core";
import { WalletConnect as WalletConnectV2 } from "@web3-react/walletconnect-v2";

export const [walletConnectV2, hooks] = initializeConnector(
  (actions) =>
    new WalletConnectV2({
      actions,
      options: {
        projectId: "2e08e2e28c4654badabe54a47b6f5392",
        // projectId: "fe76d54c3385e26a8188e9ff4f618ae0",
        chains: [8453],
        optionalChains: [8453],
        showQrModal: true,
        rpcMap: {
          56: "https://bsc-dataseed.binance.org/",
        },
      },
      metadata: {
        name: "Luckify App",
        description: "bet app ",
        url: "https://dev-luckify.quecko.org/",
      },
      onError: (err) => {
        localStorage?.clear();
      },
    })
);
